export const possible_statuses = {
    offer: {
        approved: 'approved',
        open: 'open',
        closed: 'closed',
        draft: 'draft',
    },
    userStatus: {
        pending: 'pending',
        active: 'active',
    },
    userType: {
        admin: 'ADMIN',
        normal: 'NORMAL',
    },
    token: {
        expired: 'Token is Expired',
        not_found: 'Authorization Token not found',
    },
};
